export const HIGHWAY_URL = 'https://highway.com/go/ryan-transportation';
export const CARRIER_COMPLIANCE_EMAIL = 'highwaysupport@ryanrts.com';
